import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface Props {
  clienteId: string;
  nombre: string;
  nifCif: string | null;
}

export const ClienteDuplicadoLocalCard: React.FC<Props> = ({ clienteId, nombre, nifCif }) => {
  const navigate = useNavigate();
  return (
    <Card className="border-destructive/40 bg-destructive/5">
      <CardContent className="pt-4 pb-4 flex items-start gap-3">
        <div className="rounded-full bg-destructive/15 p-2">
          <AlertTriangle className="h-5 w-5 text-destructive" />
        </div>
        <div className="flex-1 min-w-0 space-y-1">
          <h3 className="font-semibold text-sm">Este CIF/NIF ya está dado de alta</h3>
          <p className="text-xs text-muted-foreground">
            Ya existe un cliente con el mismo NIF/CIF en tu empresa: <strong className="text-foreground">{nombre}</strong>
            {nifCif ? ` (${nifCif})` : ''}. No se puede crear duplicado.
          </p>
          <div className="pt-2">
            <Button size="sm" variant="outline" onClick={() => navigate(`/clientes/${clienteId}`)}>
              Ver cliente existente
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
